import React from "react";
import "../css/about.css";
import charla from "../img/charla.png";
import innovacion from "../img/innovacion.png";
import mejores_practicas from "../img/mejores_practicas.png";
import proteger from "../img/proteger.png";
import { Helmet } from "react-helmet";
export default function About() {
  return (
    <section className="about">
      <Helmet>
        <title>
          About Panamarine Repair | Yacht and Diesel Engine Experts in Panama
        </title>
        <meta
          name="description"
          content="With over 20 years in Panama, Panamarine Repair specializes in yacht and diesel engine repair, certified maintenance, and marine innovation. Discover our mission and vision."
        />
        <meta
          name="keywords"
          content="yacht repair Panama, marine maintenance Panama, boat repair, Panamarine Repair, yacht services"
        />
        <meta property="og:title" content="About Us | Panamarine Repair" />
        <meta
          property="og:description"
          content="Learn more about Panamarine Repair, our commitment to innovation, safety, and quality yacht repair services."
        />
        <link rel="canonical" href="https://panamarinerepair.com/about" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Panamarine Repair" />
      </Helmet>
      <h1>
        About <span>us</span>
      </h1>
      <h2 className="title-mission">
        Trusted Diesel Engine <span> Experts in Panama</span>
      </h2>
      <p className="text-about">
        At Panamarine Repair, we bring over 40 years of global expertise and
        more than 20 years of trusted service in Panama. Our certified
        technicians specialize in diesel engine repair and preventive
        maintenance, ensuring your vessel stays in top condition and under
        factory warranty. Whether you're docked in Panama or transiting the
        Canal, count on us for fast, dependable service that keeps your voyage
        on course. At PANAMARINE REPAIR, our mission is to provide yacht owners
        and enthusiasts with unparalleled yacht repair and maintenance services
        that blend technical expertise and innovation, we are dedicated to:
      </p>
      <div className="mission-text">
        <div className="mission-card">
          <img
            src={mejores_practicas}
            alt="Best marine repair practices Panama"
          />
          <div className="text-mission-card">
            <h3>Excellence in Marine Craftsmanship: </h3>
            <p>
              We deliver premium yacht repair, restoration, and maintenance
              services in Panama, ensuring each vessel&#39;s safety,
              performance, and visual appeal meet the highest industry
              standards.
            </p>
          </div>
        </div>
        <div className="mission-card">
          <img
            src={charla}
            alt="Customer satisfaction in yacht maintenance Panama"
          />
          <div className="text-mission-card">
            <h3>Customer-Centered Service: </h3>
            <p>
              We place yacht owners at the heart of our operation—offering clear
              communication, reliable updates, and personalized solutions that
              exceed expectations at every stage of maintenance or repair.
            </p>
          </div>
        </div>
        <div className="mission-card">
          <img
            src={innovacion}
            alt="Innovative yacht repair solutions Panama"
          />
          <div className="text-mission-card">
            <h3>Innovation in Marine Technology: </h3>
            <p>
              We constantly integrate the latest tools, diagnostics, and
              sustainable practices to improve yacht longevity, fuel efficiency,
              and onboard systems.
            </p>
          </div>
        </div>
        <div className="mission-card">
          <img src={proteger} alt="Safe yacht maintenance and repairs Panama" />
          <div className="text-mission-card">
            <h3>Uncompromising Safety Standards: </h3>
            <p>
              Our team follows strict international protocols to ensure every
              yacht repair or engine service in Panama is performed safely and
              precisely—for both crew and vessel.
            </p>
          </div>
        </div>
      </div>

      <div className="vision">
        <div className="vision-text">
          <div>
            <h2>
              Our <span>vision</span>
            </h2>
            <p>
              We envision ourselves as undisputed leaders in the global yacht
              repair industry, recognized for our technical excellence,
              exceptional customer care, and unwavering commitment to preserving
              the beauty and functionality of personal yachts and commercials
              vessels. Our vision is to be the first choice for yacht owners
              worldwide, providing repair and maintenance services that surpass
              all expectations, implementing advanced technologies and
              eco-friendly processes to enhance the performance and durability
              of every vessel we touch.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
